function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { showNotification, updateNotification } from "@mantine/notifications";
import { tokens } from "@releaseit/design-system";
import CheckCircleIcon from "@releaseit/assets/icons/check-circle.svg";
import ExclamationIcon from "@releaseit/assets/icons/exclamation.svg";
import ExclamationTriangleIcon from "@releaseit/assets/icons/exclamation-triangle.svg";
import InfoCircleIcon from "@releaseit/assets/icons/info-circle.svg";
var ICON_MAP = {
    neutral: /*#__PURE__*/ _jsx(InfoCircleIcon, {
        className: "text-gray-700"
    }),
    positive: /*#__PURE__*/ _jsx(CheckCircleIcon, {
        className: "text-success"
    }),
    negative: /*#__PURE__*/ _jsx(ExclamationIcon, {
        className: "text-error"
    }),
    warning: /*#__PURE__*/ _jsx(ExclamationTriangleIcon, {
        className: "text-warning"
    }),
    info: /*#__PURE__*/ _jsx(InfoCircleIcon, {
        className: "text-blue"
    })
};
var baseStyles = {
    root: {
        alignItems: "start",
        borderRadius: tokens.RADII.lg,
        boxShadow: tokens.SHADOWS.card,
        padding: 12,
        paddingLeft: 16
    },
    icon: {
        marginRight: 8,
        width: 32,
        height: 32,
        backgroundColor: "unset !important",
        color: "unset !important",
        "& > svg": {
            width: "100%",
            height: "100%"
        }
    },
    title: {
        fontSize: tokens.FONT_SIZES.sm,
        color: tokens.COLORS.gray[800],
        fontWeight: 500
    },
    description: {
        fontSize: tokens.FONT_SIZES.sm,
        color: tokens.COLORS.gray[600]
    }
};
export var notifications = {
    show: function show(props) {
        showNotification(_objectSpread({
            styles: baseStyles,
            icon: ICON_MAP[props.tone]
        }, props));
    },
    update: updateNotification
};
